// PWA: Service Worker anmelden (Offline-Solo), Installationsangebot merken, Online-Status.
import { writable } from 'svelte/store';

export const installPrompt = writable<null | { prompt: () => Promise<void> }>(null);
export const online = writable(typeof navigator === 'undefined' ? true : navigator.onLine);

export function setupPwa() {
  addEventListener('online', () => online.set(true));
  addEventListener('offline', () => online.set(false));
  addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    installPrompt.set(e as unknown as { prompt: () => Promise<void> });
  });
  addEventListener('appinstalled', () => installPrompt.set(null));
  if (import.meta.env.PROD && 'serviceWorker' in navigator) {
    // erst nach dem Start anmelden: das Vorhalten aller Dateien soll die erste Szene nicht ausbremsen
    const reg = () => navigator.serviceWorker.register('/sw.js').catch((e) => console.warn('Service Worker nicht angemeldet', e));
    const later = () => setTimeout(reg, 1500);
    if ((window as any).__dlrReady) later();
    else addEventListener('dlr-ready', later, { once: true });
    // Seiten ohne Spielszene (Editor, Online, Handy) melden sich nach dem Laden an
    addEventListener('load', () => setTimeout(() => !(window as any).__dlrReady && reg(), 4000), { once: true });
  }
}

/** kurzes Vibrieren am Handy (falls erlaubt und unterstützt) */
export function haptic(pattern: number | number[]) {
  try {
    if (document.documentElement.dataset.motion !== 'reduced') navigator.vibrate?.(pattern);
  } catch {
    /* egal */
  }
}
